import type { SxProps, Theme } from '@mui/material';

export type OnboardingCheckboxRowSxOptions = {
  rowPaddingY?: string;
};

/** Layout-only styles for checkbox FormControlLabel rows — spacing from Atlas Lens theme, not custom margins. */
export function onboardingCheckboxRowSx({
  rowPaddingY,
}: OnboardingCheckboxRowSxOptions = {}): SxProps<Theme> {
  return {
    m: 0,
    alignItems: 'center',
    width: '100%',
    ...(rowPaddingY !== undefined ? { py: rowPaddingY } : {}),
  };
}
